<template>
  <v-app>
    <v-main>
      <v-container
          fluid
          fill-height
          class="background-img"
          :style="backgroundStyle"
      >
        <router-view/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'DefaultLayout',
  data() {
    return {
      selectedBackground: '' as string,
      backgroundImageList: [
        require('@/assets/images/backgrounds/login-background-red.svg'),
        require('@/assets/images/backgrounds/login-background-orange.svg'),
        require('@/assets/images/backgrounds/login-background-yellow.svg'),
        require('@/assets/images/backgrounds/login-background-green.svg'),
        require('@/assets/images/backgrounds/login-background-blue.svg'),
        require('@/assets/images/backgrounds/login-background-pink.svg'),
        require('@/assets/images/backgrounds/login-background-purple.svg'),

      ] as string[],
    }
  },

  computed: {
    backgroundStyle(): Record<string, string> {
      return {
        backgroundImage: `url(${this.selectedBackground})`,
      }
    }
  },

  created() {
    const randomIndex = Math.floor(Math.random() * this.backgroundImageList.length);
    this.selectedBackground = this.backgroundImageList[randomIndex];
  }
})
</script>

<style scoped>
.background-img {
  background-size: cover;
  background-position: center;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
